import RateInput from "./RateInput";
import { Controller, useForm } from "react-hook-form";
import { useManageProductReview } from "@/api/AppApi/services/reviews";
import { useTranslation } from "@/hooks/localization/useTranslations";
import CustomButton, {
  BtnRadius,
  BtnSizes,
  BtnTypes,
} from "../../lib/CustomButton";
import InputErrorMsg from "../../common-form-builder/form-builder-helpers/InputErrorMsg";
import AttatchmentsInput from "./AttatchmentsInput";
import { useIsMobile } from "@/hooks/useIsMobile";
import ModalActionBtn from "../ReviewsModal/ModalActionBtn";
import { TempFile } from "../../common-form-builder/common-fields/hook-upload-files/upload-files-helpers/upload";
import { postProductReviewData } from "@/api/AppApi/services/reviews/interfaces";
import usePopup from "@/hooks/usePopup";
import { submitproductReviewPopupAtoms } from "@/hooks/headerHooks";
import { useRouter } from "../../lib/navigation/useRouter";

const ReviewForm: React.FC = ({}) => {
  const isMobile = useIsMobile();
  const router = useRouter();
  const t = useTranslation();
  const { handleClosePopup, popupValue } = usePopup(
    submitproductReviewPopupAtoms,
  );
  const { initialValues, product_id } = popupValue ?? {};
  const { handleSubmit, control, formState, reset, setValue, getValues } =
    useForm({ defaultValues: { ...initialValues } });
  const submitProductReview = useManageProductReview({
    onSuccess: () => {
      reset({ rating: undefined, comment: undefined, attachments: undefined });
      handleClosePopup();
      router.refresh();
    },
    onError: (_err: any) => {
      // console.log(err);
    },
    params: { product_id: product_id! },
  });
  const onSubmit = (data: any) => {
    const dataToSubmit: postProductReviewData = {
      ...data,
      attachments: data?.attachments?.map((attachment: TempFile) => ({
        file: attachment.url,
        thumbnail: attachment.thumbnail,
        type: attachment.isImage ? "image" : "video",
      })),
      type: "product",
      id: product_id,
    };
    submitProductReview.mutate(dataToSubmit);
  };
  return (
    <div>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="product-review-form">
          <div className="input-container">
            <label>{t.how_was_quality_of_the_product}</label>
            <Controller
              name="rating"
              control={control}
              rules={{
                required: t.this_field_is_required,
              }}
              render={({ field }) => (
                <RateInput rating={field?.value!} setRating={field.onChange} />
              )}
            />
            {formState?.errors.rating && (
              <InputErrorMsg
                errorMsg={formState?.errors?.rating?.message as string}
              />
            )}
          </div>
          <div className="input-container">
            <label>{t.add_your_review}</label>
            <Controller
              name="comment"
              control={control}
              rules={{
                required: t.this_field_is_required,
              }}
              render={({ field }) => (
                <textarea
                  className="textarea"
                  placeholder={t.add_your_review}
                  {...field}
                />
              )}
            />
            {formState?.errors.comment && (
              <InputErrorMsg
                errorMsg={formState?.errors?.comment?.message as string}
              />
            )}
          </div>
          <div className="input-container">
            <label>{t.add_photos_or_videos}</label>
            <AttatchmentsInput
              value={getValues("attachments") ?? []}
              setValue={setValue}
              name={"attachments"}
              hint={""}
              error={formState?.errors?.attachments?.message as string}
              control={control}
            />
          </div>
        </div>
        {isMobile ? (
          <ModalActionBtn label={t.submit} />
        ) : (
          <div className="w-100 d-flex justify-content-end mt-4">
            <CustomButton
              isSubmit
              type={BtnTypes.primary}
              size={BtnSizes.medium}
              radius={BtnRadius.small}
              fullWidth
            >
              {t.submit}
            </CustomButton>
          </div>
        )}
      </form>
    </div>
  );
};

export default ReviewForm;
